import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "offcanvas-body" }
const _hoisted_2 = { class: "h-100 d-flex flex-column justify-content-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-subtitle mb-2" }, "Seu gênero", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-subtitle mb-2" }, "Gêneros que você atende", -1)

import { computed, onMounted, ref } from "vue";
import { toTypedSchema } from "@vee-validate/zod";
import { useForm } from "vee-validate";
import { useVeeField } from "@/composables/useVeeField";
import { genderSchema } from "@/schemas/profile";
import { useSessionStore } from "@/store/useSessionStore";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import { useUpdateUser } from "@/composables/useAuth";


export default /*#__PURE__*/_defineComponent({
  __name: 'Gender',
  setup(__props) {

const sessionStore = useSessionStore();
const session = computed(() => sessionStore.session);
const submitting = ref(false);

const options = [
  { id: "female", name: "Feminino" },
  { id: "male", name: "Masculino" },
  { id: "other", name: "Outro" },
];

const acceptedGenderOptions = [
  { id: "all", name: "Todos os gêneros" },
  { id: "female", name: "Feminino" },
  { id: "male", name: "Masculino" },
];

const { handleSubmit, resetForm } = useForm({
  validationSchema: toTypedSchema(genderSchema),
  initialValues: { gender: "", accepted_gender: "all" },
});

const genderModel = useVeeField("gender");
const acceptedGenderModel = useVeeField("accepted_gender");

onMounted(() => {
  resetForm({
    values: {
      gender: session.value?.gender ?? "",
      accepted_gender: session.value?.accepted_gender ?? "all",
    },
  });
});

const { mutateAsync: updateUser } = useUpdateUser();

const submit = handleSubmit(async (values) => {
  try {
    submitting.value = true;
    await updateUser({
      id: session.value!.id,
      gender: values.gender as any,
      accepted_gender: values.accepted_gender as any,
    });
    EventBus.$emit(EventBusNames.SHOW_TOAST, {
      title: "Alterações feitas",
      msg: "Suas informações foram salvas",
    });
  } catch (error) {
    console.error(error);
  } finally {
    submitting.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_RadioInput = _resolveComponent("RadioInput")!
  const _component_FormButton = _resolveComponent("FormButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _createVNode(_component_RadioInput, {
          options: options,
          model: _unref(genderModel)
        }, null, 8, ["model"]),
        _hoisted_4,
        _hoisted_5,
        _createVNode(_component_RadioInput, {
          options: acceptedGenderOptions,
          model: _unref(acceptedGenderModel)
        }, null, 8, ["model"])
      ]),
      _createVNode(_component_FormButton, {
        label: "Concluir",
        loading: submitting.value,
        onOnClick: _unref(submit)
      }, null, 8, ["loading", "onOnClick"])
    ])
  ]))
}
}

})